<template>
  <div id="shell">
    <PolicyModal @update:visible="showPolicyModal = $event" :visible="showPolicyModal" :check="true" @onSubmit="allowPolicy" />
    <div class="shell-top-bar" v-if="shouldShowWebComponent">
      <div class="_wrap">
        <div class="app-name-wrap">
          <a href="/">
            <i class="ri ri-grid-line fs-22"></i>
          </a>
          <a :href="homeRoute">
            <div class="text-app">
              <slot name="appName">VIETNAM TOURIST </slot>
            </div>
          </a>
        </div>
        <div class="action-icons-wrap">
          <div class="action-icon notifications">
            <button @click="toggleOpNotification($event)" type="button" >
              <i :class="['bx bx-bell fs-22 ', { 'active': isNotificationOpen } ]"></i>
              <span class="notification-count">{{notificationCount}}</span>
            </button>
            <OverlayPanel ref="opNotification">
              <div class="listNotification scroll-container" ref="scrollContainer" @scroll="handleScroll" >
                <h5 class="py-2 fw-bold text-black">{{ $t('thongbao') }}:</h5>
                <Notification :listNotification="listNotification" :userId="userId"/>
                <div v-if="loading" >
                  <div class="d-flex flex-wrap item-notf" >
                    <div class="avatar-notf">
                      <Skeleton size="3rem" class="mr-2"></Skeleton>
                    </div>
                    <div class="content-notf">
                      <div class="title-notf">
                        <Skeleton width="10rem" class="mb-2"></Skeleton>
                        <Skeleton height=".5rem" class="mb-2"></Skeleton>
                      </div>
                      <div class="time-notf">
                        <Skeleton width="5rem" ></Skeleton>
                      </div>
                    </div>
                  </div>
                  <Skeleton height="2rem" class="my-2"></Skeleton>
                  <Skeleton height="2rem" class=""></Skeleton>
                </div>
              </div>
            </OverlayPanel>
          </div>
          <div class="action-icon user" @click="toggleUserPanel">
            <img v-if="userAvatar"  :src="upload(userAvatar,'avatar')" alt="User Avatar" class="user-avatar" >
            <img v-else  src="@shared/assets/images/no-avatar-blue.jpg" alt="No Avatar" class="user-avatar">
            <span class="user-name">{{ userName }}</span>
            <div class="user-panel" v-if="isUserPanelOpen">
              <ul>
                <li @click="goToAccountSettings">
                  <i class="ri-file-user-fill"></i> Thiết lập tài khoản
                </li>
                <li @click="logout">
                  <i class="ri ri-logout-box-line"></i> Đăng xuất
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <slot></slot>
  </div>
</template>

<script>
import Skeleton from 'primevue/skeleton';
import Notification from '../app/components/Notification.vue'
import appConfig from "@/configs/app.config";
import {nextTick} from "vue";
import PolicyModal from "@/app/components/PolicyModalComponent"
import { useAuthStore } from "@shared/stores/auth.store";
import { ref } from "vue";
import NotificationsService from "@crm/src/services/notifications.service";
import OverlayPanel from 'primevue/overlaypanel';
import { watch } from "vue";
export default {
  props: {
     currentRoute : {
       type: String,
       default: "Home"
     },
     homeRoute : {
       type: String,
       default: "Home"
     }
  },
  components: {
  
    PolicyModal, Notification,OverlayPanel,Skeleton
  },
 
  
  data() {
    return {
      showPolicyModal:false,
      shouldShowWebComponent: true,
      isUserPanelOpen: false,
      userAvatar: '', // Đường dẫn đến avatar mặc định
      userName: 'John Doe', // Tên user mặc định,
      userId: '',
      departmentId: '', 
      notificationCount: 0,
      listNotification:ref([]),
      isNotificationOpen:false,
      page : ref(1),
      perpage : ref(15),
      loading : false,
      hasMore :true,
      opNotification: ref(null),
    }
  },
  setup() {
    console.log("setup-shell:");
    const excludedRouteNames = [
      'login',
      'register',
      'forgot-password',
      'tours.rate.sale.view',
      'tours.rate.executive.view',
      'tours.rate.customer'
    ]; // Add the route names you want to exclude
    const authStore = useAuthStore();
    watch(
      () => authStore, // Theo dõi sự thay đổi của user
      (newUser, oldUser) => {
        console.log("User updated:", newUser, oldUser);
        // Thực hiện thêm logic nếu cần
      },
      { deep: true } // Theo dõi sâu nếu user là object
    );
    return {
      user: authStore.user,
      excludedRouteNames,
      authStore,
    }
  },
 
  created() {
  },
  computed: {
    
  },
  methods: {
    
    toggleOpNotification(event){
      if (this.$refs.opNotification) {
        this.$refs.opNotification.toggle(event);
      } else {
        console.error("opNotification chưa được khởi tạo");
      }
    },
    closeOpNotificationOnScroll() {
      if (this.$refs.opNotification) {
        this.$refs.opNotification.hide();
      }
    },
    handleScroll (){
      const container = this.$refs.scrollContainer;
      if (
          !this.loading && 
          container.scrollTop + container.clientHeight >= container.scrollHeight - 10
          ) {
              this.getData(this.userId,this.departmentId);
          }

    },
    getData(id_user,id_department) {
      if (this.loading || !this.hasMore) return
      this.loading = true

      const requestData = {
        id_user:id_user,
        id_department:id_department,
        page: this.page,
        perpage: this.perpage,
      };
      this.loading = true;
      NotificationsService.getList(requestData).then((response) => {
        if (response.data.data) {
          this.listNotification.push(...response.data.data.data.data);
          this.notificationCount=response.data.data.unread_count;
          this.loading = false;
          this.page++;
          if(response.data.data.data.current_page * response.data.data.data.per_page >= response.data.data.data.total)this.hasMore=false;
        }else{
          this.hasMore=false;
        }
      });
    },
    
    allowPolicy(allow){
   
      if(!allow){
        this.logout();
      }else{
        
        this.authStore.allowPolicy();
      }
    }, 
    upload(file,patch){
      return  appConfig.APP_UPLOAD+(patch?(patch+"/"):'')+file
    },
    toggleUserPanel() {
      this.isUserPanelOpen = !this.isUserPanelOpen;
    },
    goToAccountSettings() {
      // Xử lý chuyển đến trang thiết lập tài khoản
      // this.$router.push({
      //   path: "/crm/staff/edit",
      //   params: {
      //     id: this.userId,
      //   },
      // });
      this.isUserPanelOpen = false;
      window.location.href=`/personal/staff/edit/${this.userId}`;
    },
    async logout() {
      localStorage.removeItem("user");
      localStorage.removeItem("status");
      localStorage.removeItem("pem");
      // Điều hướng sau khi đăng xuất
      nextTick(async () => {
        try {
          await this.$router.push('/login');  // hoặc route bạn muốn chuyển đến sau khi đăng xuất
        } catch (error) {
          console.error('Navigation error:', error);
        }
      });
    }
  },
  mounted() {
    window.addEventListener('scroll', this.closeOpNotificationOnScroll);
    // this.shouldShowWebComponent = computed(() => {
    //   let self = this;
    //   if (!self.currentRoute) return false;
    //   console.error(self.excludedRouteNames);

    //   // alert((self.currentRoute));
    //   return !self.excludedRouteNames.includes(self.currentRoute.name);
    // });

    // const user = ref(JSON.parse(localStorage.getItem('user')) || null);

    if (this.user) {  // Sử dụng `.value` để truy cập giá trị
      this.userAvatar = this.user.avatar || this.userAvatar;  // Sử dụng `.value`
      this.userName = this.user.name || this.userName;  // Sử dụng `.value`
      this.userId = this.user.id || this.userId;  // Sử dụng `.value`
      this.departmentId = this.user?.info?.work?.department || this.departmentId;  // Sử dụng `.value`
      if (!this.user.allow_policy) {  // Sử dụng `.value`
        this.showPolicyModal = true;
      }
      this.getData(this.userId, this.departmentId);
    }

  }
}
</script>

<style>
._wrap {
  height: 45px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 25px;
}
.shell-top-bar {
  display: block;
  position: sticky;
  background: #fff;
  z-index: 10;
  width: 100%;
  top: 0;
  height: 45px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}
.text-app {
  font-size: 22px;
  font-weight: bold;
  margin-left: 15px;
}
.app-name-wrap {
  display: flex;
  align-items: center;
  height: 45px;
}
.action-icons-wrap {
  display: flex;
  align-items: center;
}
.action-icon {
  margin-left: 20px;
  cursor: pointer;
  position: relative;
  padding-right: 8px;
}
.action-icon i{
  font-size: 20px;
  width: 30px;
  height: 30px;
  background: #9ca2a5;
  border-radius: 50%;
  text-align: center;
  color: #fff;
  line-height: 30px;
  display: inline-block;
}
.action-icon i.active{
  background: #47afe3;
}
.notifications {
  position: relative;
}
.listNotification{
  /* top: 46px;
  right: 5px; */
  /* background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000; */
  min-width: 300px;
  /* position: fixed;
  padding: 10px; */
  max-height: calc(100vh - 50px);
  overflow: auto;
}
.notifications button{
  background: transparent;
  border:0;
}
.notifications .notification-count {
    position: absolute;
    top: -5px;
    right: 0px;
    background-color: red;
    color: white;
    border-radius: 50%;
    padding: 1px 6px;
    font-size: 10px;
}
.navbar-menu {
  top: 45px!important;
}
.app-search {
  display: none!important;
}
.page-content {
  padding: calc(10px + 1.5rem) calc(1.5rem* 0.5) 60px calc(1.5rem* 0.5)!important;
}
@media (min-width: 768px) {
  #page-topbar {
    display: none;
  }
  .topnav-hamburger {
    display: none!important;
  }
}

.user {
  display: flex;
  align-items: center;
  cursor: pointer;
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 10px;
}

.user-name {
  font-size: 14px;
  font-weight: 500;
  margin-right: 10px;
}

.user-panel {
  top: 100%;
  right: -25px;
  background: white;
  border: 1px solid #ddd;
  border-radius: 4px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  z-index: 1000;
  min-width: 200px;
  position: absolute;
}

.user-panel ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.user-panel li {
  padding: 10px 20px;
  cursor: pointer;
  white-space: nowrap;
  display: flex;
  align-items: center;
  border-bottom: 1px solid #f0f0f0; /* Dấu gạch ngăn cách nhẹ nhàng */
}

.user-panel li:last-child {
  border-bottom: none; /* Loại bỏ dấu gạch cho item cuối cùng */
}

.user-panel li:hover {
  background-color: #f5f5f5;
}

.user-panel li i {
  margin-right: 10px;
  font-size: 18px;
}
</style>